import firebase from '../../firebase/compat'
import { client } from '../../hooks/Client'

// Definitief verwijderen loopt via de server (functions/trash/purgeTrash.js):
// alleen voor wie roles.manage heeft, alleen wat al in de prullenbak ligt, en
// met een regel in PurgeLog. De browser kan hier niets zelf.
// AI-CONTEXT: See docs/plans/prullenbak.md (fase 4)

const MELDINGEN = {
    forbidden: 'Alleen wie rollen mag beheren, kan definitief verwijderen.',
    'not-found': 'Dit onderdeel bestaat niet meer. Ververs de pagina.',
    'not-in-trash': 'Dit onderdeel ligt niet (meer) in de prullenbak. Ververs de pagina.',
    'invalid-collection': 'Dit soort onderdeel kan niet definitief verwijderd worden.',
}

/** De melding bij een status die geen 'success' is. */
export const purgeStatusMessage = (status) =>
    MELDINGEN[status] || 'Definitief verwijderen is mislukt. Probeer het opnieuw.'

const call = (name, payload) =>
    firebase.app().functions('europe-west1').httpsCallable(name)({ client, ...payload }).then((r) => r.data || {})

/**
 * @param {{ Collection: string, DocID: string }} item
 * @returns {Promise<{ status: string, documents?: number, files?: number }>}
 */
export const purgeTrashItem = (item) => call('purgeTrashItem', { collection: item.Collection, docId: item.DocID })

/** @returns {Promise<{ status: string, items?: number, more?: boolean }>} */
export const emptyTrash = () => call('emptyTrash', {})
